angular.module('zc.zenclerkS')
  .component('zcsCampaignEditStepDesign', {
    templateUrl: '/templates/zenclerk_s/sites/campaigns/edit/campaign_edit_step_design.html',
    require: {
      campaignEdit: '^zcsCampaignEdit'
    },
    controller: ZcsCampaignEditStepDesignController
  });

ZcsCampaignEditStepDesignController.$inject = ['$state', 'Template', 'ZcsCampaignElementCreator'];
function ZcsCampaignEditStepDesignController($state, Template, ZcsCampaignElementCreator) {
  const vm = this;

  this.$onInit = () => {
    vm.campaign = this.campaignEdit.campaign;
    vm.project = this.campaignEdit.project;

    vm.selectedTemplate = undefined;
    vm.selectTemplate = selectTemplate;
    vm.selectableTemplates = ZcsCampaignElementCreator.getSelectableTemplates(vm.project);
    vm.isNewTemplate = isNewTemplate;

    if(!_.get(vm.campaign, 'incentives[0].coupon_code') && !vm.campaign.incentive_draft.coupon_code) {
      $state.go('zenclerkS.project.campaign.edit.coupon', { apikey: vm.project.apikey, campaignId: vm.campaign.id });
      // We need to return or message gets set on reload, and might cause
      // problems!
      return;
    }

    // if no element message
    // FIXME: color picker puts #FFFFFF as message colors before we get into this part,
    // so the selectTemplate does not run when coming in this state
    // (so that's why checking code_title also)
    if(_.isEmpty(vm.campaign.element.message) || !vm.campaign.element.message || !vm.campaign.element.message.code_title) {
      selectTemplate(vm.selectableTemplates[0]);
    }
  };

  function selectTemplate(selectedTemplate) {
    ZcsCampaignElementCreator.createCampaignElement(vm.campaign, vm.project, selectedTemplate);
  }


  function isNewTemplate(template) {
    // newly released templates should be 1 "NEW" for 1 month
    return template.release_date && moment().isBefore(moment(template.release_date).add(1, 'month'));
  }

}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/sites/campaigns/edit/campaign_edit_step_design.js